module.exports = __webpack_public_path__ + "img/icon_linkedin.fed82f83.svg";